import * as React from 'react';
import { UserConditionModel } from "../../../models/user/userConditionModel";
import * as HelperFunctions from '../../../common/functions/helperFunctions';
import { UserConditionType } from '../../../common/enums';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import CSSTransition from 'react-transition-group/CSSTransition';
import Translate from '../../../common/functions/translate';

const userConditionList = (props) => {
    const listItems = <ul className="list-items">
        {props.userConditions.map((m: UserConditionModel) =>
            <li key={m.userConditionId + 'cond'}>
                <div className="item-info" onClick={() => props.addClick(m.userConditionId)}>
                    <div className="item-name" style={{ fontWeight: 600 }}>
                        {m.isSystemType ?
                            <>
                                <div>
                                    {HelperFunctions.getEnumLabel(m.userConditionTypeId, UserConditionType, true) +
                                        " " + "(" + HelperFunctions.getUnitByConditionType(m.userConditionTypeId) + ")"}
                                </div>
                            </>
                            :
                            <div>
                                {m.personalCondition}
                            </div>}
                    </div>
                    {/* <div className="item-desc">
                        {m.userConditionTypes.map(u =>
                            <div key={u.isSystemType ? u.userConditionTypeId + 'condType' : u.userConditionTypeId + 'personal'} style={{ width: '100%' }}>
                                {u.isSystemType ?
                                    <>
                                        <div style={{ color: u.userConditionTypeId == props.filterByType ? 'red' : '#999' }}>
                                            {HelperFunctions.getEnumLabel(u.userConditionTypeId, UserConditionType, true)}:
                                            <span style={{ color: '#444' }}> {u.userConditionValue} {u.userConditionUnit}</span>
                                        </div>
                                    </>
                                    :
                                    <div>
                                        {u.personalCondition}: <span style={{ color: '#444' }}> {u.userConditionValue}</span>
                                    </div>}
                            </div>)}
                    </div> */}
                </div>
                <div className="item-actions" onClick={() => props.addClick(m.userConditionId)} style={{ paddingLeft: 5 }}>
                    <FontAwesomeIcon icon={faChevronRight} />
                </div>

            </li>
        )}
    </ul>;

    return (
        <>
            {listItems}
        </>
    )
}

export default userConditionList;
